import {
  formatTrialDateDisplay,
  formatTrialTimeRange,
} from '~shared/helpers/format-trial-datetime';

export function buildTrialRescheduleSlotLabel(
  slot: { startTime: string; endTime: string },
  timezone?: string | null,
): string {
  const date = formatTrialDateDisplay(slot.startTime, timezone);
  const range = formatTrialTimeRange(
    slot.startTime,
    slot.endTime,
    timezone,
  );
  return range ? `${date} ${range}` : date;
}
